const DEV_FALLBACK = "https://localhost:5000";

export const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || DEV_FALLBACK
).replace(/\/$/, "");

if (
  process.env.NODE_ENV === "production" &&
  !process.env.REACT_APP_API_BASE_URL
) {
  console.warn(
    "REACT_APP_API_BASE_URL is not set. API calls will use localhost fallback."
  );
}
